var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMusicNotesSimple = function SvgIconMusicNotesSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.5 3a1 1 0 0 0-1.242-.97l-12 3A1 1 0 0 0 6.5 6v9.884a3.625 3.625 0 1 0 2 3.241V6.781l10-2.5v8.603a3.625 3.625 0 1 0 2 3.241zm-2 13.125a1.625 1.625 0 1 0-3.25 0 1.625 1.625 0 0 0 3.25 0m-12 3a1.625 1.625 0 1 0-3.25 0 1.625 1.625 0 0 0 3.25 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconMusicNotesSimple;